import { v4 as uuidv4 } from 'uuid';


export const suggestionPassword = async (id?: any) => {

   return id = uuidv4()
}